import { NOTES_URL } from "../constants";
import { apiSlice } from "./apiSlice";



export const notesApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getNotes: builder.query({
            query: () => ({
                url: NOTES_URL,
            }),
            keepUnusedDataFor:5
        }),
        getNoteDetails: builder.query({
            query: (noteId) => ({
                url: `${NOTES_URL}/${noteId}`,
            }),
            keepUnusedDataFor:5
        }),
        createNote: builder.mutation({
            query: (data) => ({
                url: NOTES_URL,
                method: 'POST',
                body: data,
            }),
            invalidatesTags:['Notes']
        }),
        getNotesBySite: builder.query({
            query: (siteId) => ({
                url: `${NOTES_URL}/site/${siteId}`,
            }),
            invalidatesTags:['Notes']
        }),
        updateNote: builder.mutation({
            query: (data) => ({
                url: `${NOTES_URL}/${data._id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags:['Notes']
        }),
        deleteNote: builder.mutation({
            query: (noteId) => ({
                url: `${NOTES_URL}/${noteId}`,
                method: 'DELETE',
            }),
        }),
    })
});

export const {useGetNotesQuery, useGetNoteDetailsQuery, useGetNotesBySiteQuery, useCreateNoteMutation, useUpdateNoteMutation, useDeleteNoteMutation} = notesApiSlice;